import React, { useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';

import { ordersApi } from 'api';
import {
  ReceiptsModal as BaseReceiptsModal,
  CloseDialogResult,
  DialogProps,
} from 'components';
import { OrderType, QueryKey } from 'enums';
import { useUser } from 'hooks';
import { Order } from 'types';

type Props = {
  order: Order;
} & DialogProps;

export const ReceiptsModal: React.FC<Props> = ({ open, order, onClose }) => {
  const { apiRole } = useUser();

  const queryKey = useMemo(
    () => [QueryKey.PayinOrderReceipts, order?.id],
    [order],
  );
  const queryResultReceipts = useQuery(
    queryKey,
    () => ordersApi.getOrderReceiptsAsRole(apiRole)(order.id),
    { enabled: open && !!order?.id },
  );

  const handleClose = useCallback(
    (result: CloseDialogResult) => {
      queryResultReceipts.remove();
      onClose(result);
    },
    [queryResultReceipts, onClose],
  );

  return (
    <BaseReceiptsModal
      open={open}
      orderId={order?.id}
      orderType={OrderType.Payin}
      queryResult={queryResultReceipts}
      onClose={handleClose}
    />
  );
};
